// @flow

import React from 'react';
import styled from 'styled-components';
import { PrimaryButton, AdvisorBlankButton } from 'styles/Buttons';
import { ContractRoundedButton } from 'styles/Buttons';
import {
  isValidFileType,
  showAcceptFileTypes
} from 'validations/HomieValidations';

const Container = styled.div`
  width: 100%;
  position: relative;
  & input[type='file'] {
    width: 0;
    height: 0;
    opacity: 0;
  }
`;

const FileButton = styled(PrimaryButton)`
  width: 100%;
  height: ${({ height }) => height};
  background-color: ${({ color }) => color || '#278C7E'} !important ;

  &:hover {
    background-color: ${({ color }) => color || '#278C7E'} !important ;
    opacity: 0.5;
  }
`;

const FileBlankButton = styled(AdvisorBlankButton)`
  width: 100%;
  color: ${({ color }) => color || '#E1701D'};
  height: ${({ height }) => height};
`;

type StateType = {};

type PropsType = {
  text: string,
  accept: string,
  advisorStyle?: boolean,
  contractButton?: boolean,
  color?: String,
  onSelectFiles: (files: Array<File>) => void,
  disabledButton: boolean,
  multipleFile: boolean,
  height: string,
  onError: (message: string) => void,
  clearError: () => void
};

export default class ButtonUploadFileComponent extends React.Component<
  PropsType,
  StateType
> {
  eventInputFile: any;
  static defaultProps = {
    advisorStyle: false,
    contractButton: false,
    multipleFile: true,
    height: '32px'
  };
  constructor(props: PropsType) {
    super(props);
    this.state = {};
    this.eventInputFile = null;
    this.onSelectFiles = this.onSelectFiles.bind(this);
    this.saveInputEvent = this.saveInputEvent.bind(this);
    this.addNewFile = this.addNewFile.bind(this);
  }

  saveInputEvent = (e: any) => {
    this.eventInputFile = e;
  };

  addNewFile = () => {
    this.eventInputFile.click();
  };

  renderFileButton = () => {
    const { text, advisorStyle, color, contractButton, height } = this.props;
    if (advisorStyle) {
      return (
        <FileBlankButton
          type="button"
          onClick={() => this.addNewFile()}
          color={color}
          height={height}
        >
          {text}
        </FileBlankButton>
      );
    }

    if (contractButton) {
      return (
        <ContractRoundedButton
          type="button"
          onClick={() => this.addNewFile()}
          disabled={this.props.disabledButton}
          height={height}
        >
          {text}
        </ContractRoundedButton>
      );
    }

    return (
      <FileButton
        type="button"
        onClick={() => this.addNewFile()}
        height={height}
        color={color}
      >
        {text}
      </FileButton>
    );
  };

  onSelectFiles(e) {
    e.preventDefault();
    let files = [];
    let countErrors = 0;
    for (let i = 0; i < e.target.files.length; ++i) {
      if (this.props.accept === undefined) {
        files.push(e.target.files[i]);
      } else if (isValidFileType(e.target.files[i], this.props.accept)) {
        files.push(e.target.files[i]);
      } else {
        countErrors += 1;
      }
    }
    if (countErrors > 0) {
      this.props.onError(
        `Ingresa un tipo de archivo válido. (${showAcceptFileTypes(
          this.props.accept
        )})`
      );
    } else {
      this.props.clearError();
    }
    this.props.onSelectFiles(files);
    e.target.value = null;
  }

  render() {
    const { accept, multipleFile } = this.props;
    return (
      <Container>
        <input
          ref={this.saveInputEvent}
          accept={accept}
          type="file"
          onChange={this.onSelectFiles}
          multiple={multipleFile}
        />
        {this.renderFileButton()}
      </Container>
    );
  }
}
